export default "__VITE_ASSET__CkBOXU$8__"